const rushReqOptions = [
  { label: "Regular", value: 1 },
  { label: "Rush", value: 2 },
  { label: "Abbreviated", value: 3 },
];

export default rushReqOptions;
